// extracted by mini-css-extract-plugin
export default {"field":"FilterPanel_field__FzngP"};